const page_manager = {
  lastpage: 0,
  showbrain: false,
  pagedata: [
    { id: 0, name: "main", active: true, scroll: 0 },
    { id: 1, name: "full", active: false, scroll: 0 },
    { id: 2, name: "test", active: false, scroll: 0 },
    { id: 3, name: "modal", active: false, scroll: 0 },
    { id: 4, name: "finish", active: false, scroll: 0 },
  ],
};

export default page_manager;
